import { executeRequest } from "@maersk-global/shared-js";
import { getEnvConfig } from "@/config/envConfig";

enum HttpProtocol {
  http = "http://",
  https = "https://"
}

export const CONTENT_TYPES = {
  JSON: "application/json",
  MULTIPART: "multipart/form-data",
  OCTET: "application/octet-stream",
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
};

export enum HTTP_METHODS {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE"
}

export type HttpRequest = {
  endPoint: string;
  method?: keyof typeof HTTP_METHODS;
  body?: BodyInit | any;
  headers?: { [key: string]: any };
  rawResponse?: boolean;
};

export async function makeRequest({
  endPoint,
  method,
  body,
  headers = {},
  rawResponse = false
}: HttpRequest): Promise<any> {
  const headersObj = _setHeaders(headers);

  if (body && headersObj.get("Content-Type") === CONTENT_TYPES.JSON) {
    body = JSON.stringify(body);
  }

  const url: string = _setUrl(endPoint);

  try {
    return await executeRequest({ url, method, body, headers: headersObj, authorizedRequest: false, rawResponse });
  } catch (error) {
    if (error instanceof Response) {
      throw error;
    }
    throw error;
  }
}

export function createUrlQueryParams(url: string, params = {}): string {
  if (Object.entries(params).length > 0) {
    const queryParams = new URLSearchParams(params).toString();
    return url + `?${queryParams}`;
  }

  return url;
}

function _setHeaders(headers: any = {}): Headers {
  const headersObj = new Headers();
  Object.keys(headers).forEach((key) => {
    headersObj.set(key, headers[key]);
  });

  return headersObj;
}

export function _setUrl(endPoint: string, otherAPIDomain?: string) {
  const config = getEnvConfig();
  let apiDomain = null;

  if (endPoint.startsWith(HttpProtocol.http) || endPoint.startsWith(HttpProtocol.https)) {
    return endPoint;
  }
  if (otherAPIDomain) {
    apiDomain = config[otherAPIDomain];
  } else {
    apiDomain = config.apiDomain;
  }

  if (apiDomain === "http://localhost:5001" && !endPoint.startsWith("/api")) {
    // the Mock server needs the /api prefix
    apiDomain += "/api";
  }

  return apiDomain + endPoint;
}
